
const Footer = () => {
  return (
    <footer className="bg-background border-t border-border py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-muted-foreground">
            © 2024 Bromentum. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
